export const FINDER_FILTER_MENU_ICON = "filter-settings";
